import React, { FC, memo, useMemo } from 'react'

import { useWatch } from 'react-hook-form'

import useToggle from 'Hooks/useToggle'
import { PaymentMethods } from 'Types'

import { usePayment } from '../Provider'

import Modal from './Modal'

interface Props {
  isPaymentRequired: boolean
}

const Terms: FC<Props> = ({ isPaymentRequired }) => {
  const { gateway } = usePayment()
  const paymentMethod = useWatch({ name: `${gateway.field}.paymentMethod` })
  const [termsModalVisibility, , openTermsModal, closeTermsModal] = useToggle()

  const renderBtnText = useMemo(() => {
    if (!isPaymentRequired) return '“Order now“'
    switch (paymentMethod) {
      case PaymentMethods.CARD:
        return '“Pay Now”'
      case PaymentMethods.APPLE_PAY:
        return '“Order with Apple Pay”'
      case PaymentMethods.GOOGLE_PAY:
        return '“Order with Google Pay”'
      default:
        return '“Pay Now”'
    }
  }, [isPaymentRequired, paymentMethod])

  return (
    <>
      <p className="terms-link-wrapper">
        By clicking the {renderBtnText} button, you agree and accept our{' '}
        <a className="text-underline" onClick={openTermsModal}>
          terms of sale
        </a>
        .
      </p>
      {termsModalVisibility ? <Modal closeModal={closeTermsModal} /> : null}
    </>
  )
}

export default memo(Terms)
